import { makeStyles } from '@material-ui/core';

import { blue, neutral, teal } from 'shared/styles/colors';

import { Color, SwitchModeIOSProps } from './switchModeIOS.model';

const COLOR = {
  primary: teal['50'],
  secondary: blue['50'],
} as Record<Color, string>;

export default makeStyles({
  container: {
    height: 'calc(1.5rem + 2px)',
  },
  label: ({ color, checked = false }: Props) => ({
    position: 'relative',
    width: '2.5rem',
    height: 'calc(1.5rem + 2px)',
    display: 'inline-block',
    cursor: 'pointer',
    borderRadius: '1rem',
    border: `1px solid ${COLOR[color]}`,
    backgroundColor: checked ? COLOR[color] : neutral['50'],
    transition: 'background-color 0.2s',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '2px',
      left: '2px',
      width: '1.25rem',
      height: '1.25rem',
      borderRadius: '50%',
      backgroundColor: neutral['10'],
      transition: 'transform 0.2s',
      transform: checked ? 'translateX(0.875rem)' : 'none',
    },
  }),
  checked: {
    display: 'none',
  },
});

interface Props {
  color: Color;
  checked?: SwitchModeIOSProps['checked'];
}
